

import React, { useState } from "react";
import { Box, Grid, Typography, Stack, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import ComingSoon from "../Utils/ComingSoon"; // 👈 adjust path as needed

const Dashboardfooter = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const [comingSoonOpen, setComingSoonOpen] = useState(false);

  const handleComingSoon = () => setComingSoonOpen(true);

  return (
    <>
      <ComingSoon
        open={comingSoonOpen}
        onClose={() => setComingSoonOpen(false)}
      />

      <Box
        sx={{
          backgroundColor: isDark ? "#0B1C30" : "#f5f5f5",
          color: "white",
          px: { xs: 2, md: 4 },
          pt: 6,
          pb: 3,
          mt: 4,
        }}
      >
        <Grid container spacing={3}>
          {/* Company */}
          <Grid
            size={{ xs: 12, md: 2, sm: 6 }}
            item
            xs={12}
            sm={6}
            md={3}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
            }}
          >
            <Box
              component="img"
              src="/Assets/logotanobg.png"
              sx={{
                height: {
                  xs: 55,
                  md: 85,
                },
                width: {
                  xs: 120,
                  md: 170,
                },
                objectFit: "contain",
                ml: -1,
              }}
            />
            <Typography variant="body2" color="gray">
              1st Floor, Satyam Arcade, 4,
              <br />
              BTM 2nd Stage, BTM Layout,
              <br />
              Bengaluru, Karnataka - 560076
            </Typography>
            <Typography variant="body2" color="gray">
              📞 +91-9390358339
            </Typography>
            <Typography variant="body2" color="gray">
              📧 support@taipl.in
            </Typography>
          </Grid>

          {/* BBPS + Cards (same row mobile) */}
          <Grid size={{ xs: 6, md: 2 }} item xs={6} md={2}>
            <Typography fontWeight="bold" color="black">
              BBPS Services
            </Typography>
            <Typography
              component={Link}
              to="/dashboard/bbps/mobileprepaid"
              variant="body2"
              sx={{ color: "gray", textDecoration: "none", display: "block" }}
            >
              Recharge
            </Typography>
            <Typography
              component={Link}
              to="/dashboard/bbps/dth"
              variant="body2"
              sx={{ color: "gray", textDecoration: "none", display: "block" }}
            >
              DTH
            </Typography>
            <Typography
              component={Link}
              to="/dashboard/bbps/municipal-tax"
              variant="body2"
              sx={{ color: "gray", textDecoration: "none", display: "block" }}
            >
              Taxes
            </Typography>
            <Typography
              component={Link}
              to="/dashboard/bbps/gas"
              variant="body2"
              sx={{ color: "gray", textDecoration: "none", display: "block" }}
            >
              Gas Bills
            </Typography>
            <Typography
              variant="body2"
              onClick={handleComingSoon}
              sx={{ color: "gray", cursor: "pointer", display: "block" }}
            >
              Recharge
            </Typography>
          </Grid>

          <Grid size={{ xs: 6, md: 2 }} item xs={6} md={2}>
            <Typography fontWeight="bold" color="black">
              Cards
            </Typography>
            <Typography
              variant="body2"
              onClick={handleComingSoon}
              sx={{ color: "gray", cursor: "pointer" }}
            >
              Gift Card
            </Typography>
            <Typography
              variant="body2"
              onClick={handleComingSoon}
              sx={{ color: "gray", cursor: "pointer" }}
            >
              Meals Card
            </Typography>
            <Typography
              variant="body2"
              onClick={handleComingSoon}
              sx={{ color: "gray", cursor: "pointer" }}
            >
              Telecom Recharge
            </Typography>
            <Typography
              variant="body2"
              onClick={handleComingSoon}
              sx={{ color: "gray", cursor: "pointer" }}
            >
              FX Card
            </Typography>
            <Typography
              component={Link}
              to="/dashboard/rupaycard"
              variant="body2"
              sx={{ color: "gray", textDecoration: "none", display: "block" }}
            >
              RuPay
            </Typography>
          </Grid>

          {/* Digital + Support (same row mobile) */}
          <Grid size={{ xs: 6, md: 2 }} item xs={6} md={2}>
            <Typography fontWeight="bold" color="black">
              Digital
            </Typography>
            <Typography
              component={Link}
              to="/dashboard/loadmoney"
              variant="body2"
              sx={{ color: "gray", textDecoration: "none", display: "block" }}
            >
              Load Money
            </Typography>
            <Typography
              component={Link}
              to="/dashboard/wallettransfer"
              variant="body2"
              sx={{ color: "gray", textDecoration: "none", display: "block" }}
            >
              Wallet Transfer
            </Typography>
            <Typography
              component={Link}
              to="/dashboard/transfertobank"
              variant="body2"
              sx={{ color: "gray", textDecoration: "none", display: "block" }}
            >
              IMPS
            </Typography>
            <Typography
              variant="body2"
              onClick={handleComingSoon}
              sx={{ color: "gray", cursor: "pointer" }}
            >
              UPI
            </Typography>
          </Grid>

          <Grid size={{ xs: 6, md: 2 }} item xs={6} md={2}>
            <Typography fontWeight="bold" color="black">
              Support
            </Typography>
            <Typography
              component={Link}
              to="/helpcenter"
              variant="body2"
              sx={{
                color: "gray",
                textDecoration: "none",
                display: "block",
                mt: 1,
              }}
            >
              Help Center
            </Typography>

            {/* <Typography
              variant="body2"
              onClick={handleComingSoon}
              sx={{ color: "gray", cursor: "pointer" }}
            >
              Privacy Policy
            </Typography> */}
            <Typography
              component={Link}
              to="/termsandconditions"
              variant="body2"
              sx={{ color: "gray", textDecoration: "none", display: "block" }}
            >
              Terms and Conditions
            </Typography>
            <Typography
              variant="body2"
              onClick={handleComingSoon}
              sx={{ color: "gray", cursor: "pointer" }}
            >
              Feedback & Suggestions
            </Typography>
          </Grid>

          {/* App Download */}

          <Grid size={{ xs: 12, md: 2 }} item xs={12} md={3}>
            <Typography fontWeight="bold" color="black">
              Download App
            </Typography>

            <Stack
              direction="column"
              alignItems="left"
              justifyContent={{ xs: "center", md: "flex-start" }}
              mt={1}
            >
              <Box
                component="img"
                src="/Assets/Playstore.png"
                sx={{
                  width: { xs: 100, md: 120 },
                  height: { xs: "auto", md: 40 },
                  cursor: "pointer",
                }}
                onClick={() =>
                  window.open(
                    "https://apps.apple.com/in/app/ta-wallet/id1381087275",
                    "_blank",
                  )
                }
              />
              <Box
                component="img"
                src="/Assets/Googleplay.png"
                sx={{
                  width: { xs: 100, md: 120 },
                  height: { xs: "auto", md: 60 },
                  cursor: "pointer",
                }}
                onClick={() =>
                  window.open(
                    "https://play.google.com/store/apps/details?id=com.ta.wallet.tawallet&pcampaignid=web_share",
                    "_blank",
                  )
                }
              />
            </Stack>
          </Grid>
        </Grid>

        {/* Certificates */}
        <Box
          sx={{
            borderTop: "1px solid #333",
            mt: 4,
            pt: 2,
            textAlign: "center",
          }}
        >
          <Typography mb={2} color="black">
            Certifications
          </Typography>

          <Stack direction="row" justifyContent="center" spacing={2}>
            <Box
              component="img"
              src="/Assets/iso_img_1.jpg"
              sx={{ height: { xs: 35, md: 60 } }}
            />
            <Box
              component="img"
              src="/Assets/Pci_img.png"
              sx={{ height: { xs: 35, md: 60 } }}
            />
            <Box
              component="img"
              src="/Assets/iso_img_2.png"
              sx={{ height: { xs: 35, md: 60 } }}
            />
          </Stack>
        </Box>
      </Box>
    </>
  );
};

export default Dashboardfooter;
